import { useCallback } from 'react';
import { KeySequence } from 'app/lib/constants';
import { useDispatch, useMousetrap, useSelector } from 'app/lib/hooks';
import {
    doToggleWarehouseLoadDialog,
    selectIsWarehouseLoadDialogOpen
} from 'app/store/healthcheck';
import { WarehouseLoadDialog } from './WarehouseLoadDialog.jsx';

export function WarehouseLoadDialogLauncher({ ...props }) {
    const dispatch = useDispatch();
    const isOpen = useSelector(selectIsWarehouseLoadDialogOpen);

    const toggleDialog = useCallback(() => {
        dispatch(doToggleWarehouseLoadDialog());
    }, [dispatch]);

    useMousetrap(KeySequence.WAREHOUSE_LOAD_DIALOG, toggleDialog);

    return isOpen && <WarehouseLoadDialog onClose={toggleDialog} {...props} />;
}
